import { AllGeoJSON } from "@turf/helpers";

export type GeoJSON = AllGeoJSON;
